<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Wxgzhz/OEBPS/images/9781443149471_Outside_Front_Cover.jpg?1684515192871" alt="This image is the cover for the book Captain Underpants and the Preposterous Plight of the Purple Potty People, Capitaine Bobette"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Captain Underpants and the Preposterous Plight of the Purple Potty People, Capitaine Bobette
      </h1>
      <p class="bookDescription body article font2">
        <p>Georges et Harold se retrouvent dans un monde étrange, un monde à l'envers, où le directeur de l'école a le sens de l'humour, où la bibliotechnicienne suggère de bons livres, où les profs sont aimables et où la nourriture de la cafétéria ne sent pas les couches souillées. Mais ils y découvrent aussi une autre version d'eux-mêmes, vilain Georges et vilain Harold, qui s'apprêtent à mettre en ouvre quelques grotesques machinations.</p><p> </p><p>Have George and Harold completely lost their minds? Their time-traveling Purple Potty has landed them in a crazy place where the teachers are always nice, the cafeteria serves delicious food, and the school principal, Mr. Krupp, actually thinks they're funny. Something is very, very wrong -- and it gets even WRONGER when the boys' pet pterodactyl, Crackers, and Sulu the Bionic Hamster are kidnapped by George and Harold's evil-twin look-alikes. Now George and Harold must face their cleverest enemies yet: THEMSELVES! Could this be another job for the amazing Captain Underpants?</p><p>Original title: <em>Captain Underpants and the Preposterous Plight of the Purple Potty People</em></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dav Pilkey, Dav Pilkey
      </h2>
      
      <p class="authorDescription body article"><p><strong>Dav Pilkey</strong> a commencé à écrire des livres au primaire. Clown invétéré de la classe, il s&#39;attirait toujours des ennuis à force de faire rire les autres élèves et passait beaucoup de temps dans le couloir : il y a même eu son propre bureau! C&#39;est justement dans le corridor que Dav a commencé à écrire ses histoires. Dav figure aujourd&#39;hui parmi les auteurs jeunesse les plus populaires de notre temps. Publiées en 19 langues et imprimées à plus de 50 millions d&#39;exemplaires en Amérique du Nord seulement, <em>Les aventures du Capitaine Bobette</em> restent parmi les livres préférés des jeunes lecteurs. Dav habite en Oregon.</p> <p><strong>Dav Pilkey</strong> has written and illustrated several popular award-winning books for children. The <em>Adventures of Captain Underpants</em>, which has nearly one million copies in print, was an American Bookseller Pick of the Lists and a Publishers Weekly "Cuffie" Award winner for the Funniest Book of the Year; <em>Dog Breath</em> was awarded the California Young Reader Medal; <em>The Paperboy</em> was chosen as a Caldecott Honor Book. Mr. Pilkey also illustrated the IRA-CBC Children&#39;s Choice Award-winning <em>Dumb Bunnies</em> books. Dav Pilkey lives in Oregon.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Éditions Scholastic
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c78ba4c0